import { XMarkIcon } from "@heroicons/react/24/outline";
import QuantitySelector from "@/components/ui/QuantitySelector";

interface CartQuantityControlProps {
  itemKey: string;
  quantity: number;
  handleQuantityChange: (itemKey: string, value: number) => void;
  handleRemoveCartItem: (itemKey: string) => void;
}

const CartQuantityControl = ({
  itemKey,
  quantity,
  handleQuantityChange,
  handleRemoveCartItem,
}: CartQuantityControlProps) => {
  return (
    <div className="mt-auto flex gap-3">
      <QuantitySelector
        quantity={quantity}
        handleQuantityChange={(value) => handleQuantityChange(itemKey, value)}
      />
      <button onClick={() => handleRemoveCartItem(itemKey)}>
        <XMarkIcon className="box-content size-4 p-1" />
      </button>
    </div>
  );
};

export default CartQuantityControl;
